import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      role: null,
      user: null,
      login: ({ token, role }) => set({ token, role }),
      setUser: (user) => set({ user, role: user?.role ?? null }),
      logout: () => set({ token: null, role: null, user: null }),
    }),
    {
      name: 'dairy_auth',
      partialize: (state) => ({
        token: state.token,
        role: state.role,
        user: state.user,
      }),
    }
  )
);

export default useAuthStore;



